module.exports = __webpack_public_path__ + "media/icons/x-icon-cb9aa99c.png";